import { requireAuth } from "../auth/RequireAuth";
import { Dashboard, dashboardLoader } from "./dashboard";

export const dashboardRouter = {
  path: "/dashboard",
  id: "dashboard",
  element: <Dashboard />,
  loader: requireAuth(undefined, dashboardLoader),
};
